import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { Company, CompanyExperience, OverviewProvider } from '@lighty';



@Component({
    selector: 'msc-widget-resource',
    templateUrl: './resource.component.html',
    styleUrls: ['./resource.component.scss'],
})
export class WidgetResourceComponent implements OnInit {

    @Input() company: Company;
    @Input() experience: CompanyExperience;
    public resources: any[] = [];
    public loading: boolean = true;
    public baseUrl: string = 'https://mscuat2.blob.core.windows.net/production/';
    public pdfSrc = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
    constructor(private overviewProvider: OverviewProvider, private http: HttpClient) {}

    ngOnInit(): void {
        if (this.experience) {
            this.overviewProvider.getResources(this.company.id, this.experience.id).subscribe((data) => {
                this.resources = data.resources;
                this.loading = false;
            });
        }
    }

    public updateFileUrl(fileUrl: string): void {
        const url: any = this.baseUrl + fileUrl;
        this.pdfSrc = null;
        this.http.get(url, { responseType: 'blob' }).subscribe((response) => {
            const blob = new Blob([response], { type: 'application/pdf' });
            this.pdfSrc = URL.createObjectURL(blob);
        });
    }
}
